<template>
  <div id="app">
    <div class="top-bar style4">
      <div class="container">
        <div class="top-bar-inner clearfix">
          <div class="top-bar-hotline">
            <span class="hotline">
              <a href="#">
                <i class="fa fa-phone" aria-hidden="true"></i> Tel: (852) 2834
                8434
              </a>
            </span>
          </div>
          <div class="top-bar-user">
            <ul>
              <li v-if="false">
                <a>
                  <i class="fa fa-user" aria-hidden="true"></i> My Account
                </a>
              </li>
              <li>
                <a>
                  <i class="fa fa-globe" aria-hidden="true"></i> English
                  <!-- <i class="fa fa-caret-down" aria-hidden="true"></i> -->
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <header class="style4" id="header">
      <div id="site-header">
        <div class="container">
          <div class="logo">
            <a href="/">
              <img
                src="@/assets/images/megalogo_1.png"
                alt="image"
                width="129"
                height="37"
                data-retina="@/assets/images/megalogo_1.png"
                data-width="147"
                data-height="21"
                style="border-radius: 20px;"
              />
            </a>
          </div>
          <div class="mobile-button">
            <span></span>
          </div>
          <div class="nav-wrap">
            <nav id="mainnav" class="mainnav">
              <ul class="menu">
                <li
                  class="active"
                  v-bind:class="{
                    a: current_path === '/'
                  }"
                >
                  <a href="/" title="">HOME</a>
                  <ul class="sub-menu">
                    <li><a href="/about" title="">About Us</a></li>
                    <li>
                      <a href="/arrangement" title="">Delivery & Payment</a>
                    </li>
                    <li><a href="/terms" title="">Terms & Conditions</a></li>
                    <li><a href="/contactus" title="">Contact Us</a></li>
                  </ul>
                </li>
                <li
                  class="active"
                  v-bind:class="{
                    a: current_path.indexOf('/product') !== -1
                  }"
                >
                  <a href="/product" title="">PRODUCTS</a>
                  <!-- <ul class="sub-menu">                                    
                                            <li><a href="#product" title="">Australia</a></li>
                                            <li><a href="#product" title="">France</a></li>
                                            <li><a href="#product" title="">Italy</a></li>
                                            <li><a href="#product" title="">Spain</a></li>                                  
                                            <li><a href="#product" title="">France-Cognac</a></li>
                                            <li><a href="#product" title="">France Armagnac-Dartigalongue</a></li>
                                            <li><a href="#product" title="">Franch Armagnac-Baron Lustrac</a></li>
                                            <li><a href="#product" title="">Canada</a></li>
                                            <li><a href="#product" title="">Argentina</a></li>
                                         </ul> -->
                </li>
                <li
                  class="active"
                  v-bind:class="{
                    a: current_path.indexOf('/promotion') !== -1
                  }"
                >
                  <a href="/promotion" title="">SPECIAL OFFER</a>
                </li>
                <li
                  class="active"
                  v-bind:class="{
                    a: current_path.indexOf('/article') !== -1
                  }"
                >
                  <a href="/article" title="">ACTIVITIES</a>
                </li>
                <li
                  class="active"
                  v-bind:class="{
                    a: current_path.indexOf('/contactus') !== -1
                  }"
                >
                  <a href="/contactus" title="">CONTACT US</a>
                </li>
              </ul>
            </nav>
          </div>
          <!-- /.nav-wrap -->
          <div class="review" style="width:100px;">
            <div class="add-cart" v-if="false">
              <a href="#" class="like1 header-search-icon"
                ><i class="fa fa-search" aria-hidden="true"></i
              ></a>
            </div>
            <form
              class="header-search-form"
              role="search"
              method="get"
              action="#"
            >
              <input
                type="text"
                name="#"
                class="header-search-field"
                placeholder="Search..."
              />
              <button type="submit" class="header-search-submit" title="Search">
                <i class="fa fa-search"></i>
              </button>
            </form>
            <div class="add-cart" v-if="false">
              <a href="#" class="like3"
                ><i class="fa fa-shopping-cart" aria-hidden="true"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

    <footer class="style3" style="margin-top:50px;">
      <div class="container">
        <div class="footer-widgets">
          <div class="widget widget-logo">
            <a href="index.html" class="logo"
              ><img
                src="@/assets/images/megalogo_1.jpg"
                alt="image"
                width="129"
                height="37"
                data-retina="@/assets/images/megalogo_1.jpg"
                data-width="147"
                data-height="21"
            /></a>
          </div>
          <!-- /widget-logo -->
          <div class="widget widget-icon">
            <ul>
              <li>
                <a href="https://www.facebook.com/megawinehk">
                  <i class="fa fa-facebook" aria-hidden="true"></i>
                </a>
              </li>
              <!-- <li>
                <a href="#">
                  <i class="fa fa-instagram" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href="#"> <i class="fa fa-skype" aria-hidden="true"></i> </a>
              </li>
              <li>
                <a href="#">
                  <i class="fa fa-wordpress" aria-hidden="true"></i
                ></a>
              </li> -->
            </ul>
          </div>
          <!-- /widget-icon -->
          <!-- <div class="widget widget-title">
                         <h2>Get news & offers</h2>
                    </div>
                    <div class="widget widget-contact">
                         <input type="search" id="search-footer" placeholder="Your Email" >
                         <button type="submit"><i class="fa fa-location-arrow" aria-hidden="true"></i></button>
                    </div> -->
          <div class="widget widget-menu">
            <ul>
              <li><a href="/about"> About Us </a></li>
              <li><a href="/arrangement"> Delivery & Payment </a></li>
              <li><a href="/terms"> Terms & Conditions </a></li>
              <!-- <li><a href="Blog-grid-3column.html"> Privacy Policy </a></li> -->
              <li class="contact"><a href="/contactus"> Contact Us </a></li>
            </ul>
          </div>
          <!-- /widget-about -->
          <div class="widget widget-text" style="word-wrap:break-word;">
            <span
              >© 2009-{{ new Date().getFullYear() }} Mega Wine Company
              Limited</span
            >
            |<a href="https://beian.miit.gov.cn/">粤ICP备15019218号-2</a>
            <br />『根據香港法律，不得在業務過程中，向未成年人售賣或供應令人醺醉的酒類。』
            <br />"Under the law of Hong Kong, intoxicating liquor must not be
            sold or supplied to a minor in the course of business."
          </div>
        </div>
        <!-- /footer-widgets -->
      </div>
      <!-- /container -->
    </footer>
    <a id="scroll-top"><i class="fa fa-angle-right" aria-hidden="true"></i></a>
    <!-- /#scroll-top -->
    <a id="showImagePopup" href="/2020zhongqiu.png"></a
    ><!--./assets/images/2020zhongqiu.jpeg-->
  </div>
</template>
<script>
import '@/assets/bootstrap/bootstrap.css'
import '@/assets/css/style.css'
import '@/assets/css/responsive.css'
var searchIcon = function() {
  // Click-search
  $(document).on('click', function(e) {
    var clickID = e.target.id
    if (clickID !== 'input-search') {
      $('.header-search-form').removeClass('show')
    }
  })

  $('.header-search-icon').on('click', function(event) {
    event.stopPropagation()
  })

  $('.header-search-form').on('click', function(event) {
    event.stopPropagation()
  })

  $('.header-search-icon').on('click', function(event) {
    if (!$('.header-search-form').hasClass('show')) {
      $('.header-search-form').addClass('show')
      event.preventDefault()
    } else $('.header-search-form').removeClass('show')
    event.preventDefault()
  })
}
var responsiveMenu = function() {
  var menuType = 'desktop'
  $(window).on('load resize', function() {
    var currMenuType = 'desktop'

    if (matchMedia('only screen and (max-width: 991px)').matches) {
      currMenuType = 'mobile'
    }

    if (currMenuType !== menuType) {
      menuType = currMenuType

      if (currMenuType === 'mobile') {
        var $mobileMenu = $('#mainnav')
          .attr('id', 'mainnav-mobi')
          .hide()
        var hasChildMenu = $('#mainnav-mobi').find('li:has(ul)')

        $('#header .container-header ').after($mobileMenu)
        hasChildMenu.children('ul').hide()
        hasChildMenu.children('a').after('<span class="btn-submenu"></span>')
        $('.btn-menu').removeClass('active')
      } else {
        var $desktopMenu = $('#mainnav-mobi')
          .attr('id', 'mainnav')
          .removeAttr('style')

        $desktopMenu.find('.submenu').removeAttr('style')
        $('#header .container-header ')
          .find('.nav-wrap')
          .append($desktopMenu)
        $('.btn-submenu').remove()
      }
    }
  })

  $('.mobile-button').on('click', function() {
    $('#mainnav-mobi').slideToggle(300)
    $(this).toggleClass('active')
  })

  $(document).on('click', '#mainnav-mobi li .btn-submenu', function(e) {
    $(this)
      .toggleClass('active')
      .next('ul')
      .slideToggle(300)
    e.stopImmediatePropagation()
  })
}
var headerFixed = function() {
  $('#header').each(function() {
    var nav = $('#header')
    $(window).on('load', function() {
      var header = $('#header')
      var offsetTop = $('#header').offset().top
      var headerHeight = $('#header').height()
      var buffer = $('<div>', { height: headerHeight }).insertAfter(header)
      buffer.hide()

      $(window).on('load scroll', function() {
        if ($(window).scrollTop() > offsetTop) {
          $('#header').addClass('fixed-header')
          buffer.show()
        } else {
          $('#header').removeClass('fixed-header')
          buffer.hide()
        }
      })
    })
  })
}

var goTop = function() {
  $(window).scroll(function() {
    if ($(this).scrollTop() > 800) {
      $('#scroll-top').addClass('show')
    } else {
      $('#scroll-top').removeClass('show')
    }
  })

  $('#scroll-top').on('click', function() {
    $('html, body').animate({ scrollTop: 0 }, 1000, 'easeInOutExpo')
    return false
  })
}
var removePreloader = function() {
  $(window).on('load', function() {
    $('.loader').fadeOut()
    $('#loading-overlay')
      .delay(500)
      .fadeOut('slow', function() {
        $(this).remove()
      })
  })
}
var showImagePopup = function() {
  if ($().magnificPopup) {
    $('#showImagePopup').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      image: {
        verticalFit: false
      }
    })
    $('#showImagePopup').trigger('click')
  }
}
import 'magnific-popup'
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(['current_path'])
  },
  mounted() {
    searchIcon()
    responsiveMenu()
    headerFixed()
    goTop()
    // debugger
    // if (this.$route.path === '/') {
    //   showImagePopup()
    // }
    //removePreloader()
  }
}
</script>
<style lang="scss" scoped>
.product-info {
  margin: 0 auto;
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^='top'] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='right'] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^='left'] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>
